import { css } from '@emotion/core'
import React from 'react'
import { AddChildButton, AddSpouseUnknownPositionButton, AddParentButton } from '@fs/zion-add-find-flow'
import { Button, Divider } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import useSourceCentricDetailsFlag from '../../../../data-service/useSourceCentricDetailsFlag'
import { useFamilyColumnValues } from '../../../contexts/FamilyColumnContext'

const indentCss = css`
  padding-inline-start: 35px; /** to match exactly with children list */
`

export default function ButtonsSkeleton(): JSX.Element | null {
  const { type } = useFamilyColumnValues()
  const [t] = useTranslation()
  const sourceCentricFlag = useSourceCentricDetailsFlag()

  if (sourceCentricFlag.data?.isOn) {
    if (type === 'parents') return null
    return (
      <Button Icon={ContentAdd} emphasis="low" disabled data-testid="add-family-member">
        {t('tree-person.add-family-member.action')}
      </Button>
    )
  }

  return (
    <>
      {type === 'spouses' && (
        <>
          <div css={indentCss}>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <AddSpouseUnknownPositionButton disabled emphasis="inline" excludeChildren relatedSpouse={{}} />
          </div>
          <Divider marginY="xxs" />
          <div css={indentCss}>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <AddChildButton disabled />
          </div>
        </>
      )}
      {type === 'parents' && (
        <div css={indentCss}>
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <AddParentButton disabled relatedChild={{}} />
        </div>
      )}
    </>
  )
}
